import React, { useState } from 'react';
import { fetchPreviousDocumentsQuery } from 'app/edozvola/cases/previous-documents/service/previous-document.queries';
import { useParams } from 'react-router-dom';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import { PreviousDocumentsAddFormModel } from 'app/edozvola/cases/previous-documents/model/previous-documents.model';
import PreviousDocumentsDeleteModal from 'app/edozvola/cases/previous-documents/previous-documents-delete-modal';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

export interface IPreviousDocumentsTableProps {
  onRowClick: (string) => void;
}

const PreviousDocumentsTable = (props: IPreviousDocumentsTableProps) => {
  const { id } = useParams<{ id: string }>();
  const [modalOpened, setModalOpened] = useState(false);
  const [webIdToDelete, setWebIdToDelete] = useState('');
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.PREVIOUS_DOCUMENTS_TABLE);

  const deletePreviousDocument = (webId: string) => {
    setWebIdToDelete(webId);
    setModalOpened(true);
  };

  const cancelPreviousDocumentDeletion = () => {
    setWebIdToDelete('');
    setModalOpened(false);
  };

  const renderUserTableRow = (value: PreviousDocumentsAddFormModel, caseIndex: number) => {
    return (
      <tr key={caseIndex} className={invalidRowIds.includes(value.idCasePreviousDocumentMap) ? 'invalid-table-row' : ''}>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.webId}</span>
            <span>{value.finalActDocumentName}</span>
          </div>
        </td>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.classification}</span>
            <span>{value.finalActFileNumber}</span>
          </div>
        </td>
        <td>{convertDateFromServer(value.finalDocumentAdmissionDate)}</td>
        <td>{convertDateFromServer(value.executionDate)}</td>
        <td>{convertDateFromServer(value.effectivenessDate)}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon icon={'eye'} className={'icon-table'} onClick={() => props.onRowClick(value.idCasePreviousDocumentMap)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash'} className={'icon-table'} onClick={() => deletePreviousDocument(value.webId)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        initialPaginationColumn={'webId'}
        renderTableRow={renderUserTableRow}
        fetchDataQuery={fetchPreviousDocumentsQuery}
        fetchDataProps={id}
        noDataMessage={'Nema akata koji prethode.'}
      >
        <ViewTableHeaderColumn renderSort sortKey={'webId'} columnLabels={['Šifra predmeta', 'Naziv akta']} />
        <ViewTableHeaderColumn renderSort sortKey={'classification'} columnLabels={['Klasifikacijska oznaka', 'Urudžbeni broj']} />
        <ViewTableHeaderColumn renderSort sortKey={'solutionDate'} columnLabels={['Datum rješavanja']} />
        <ViewTableHeaderColumn renderSort sortKey={'executionDate'} columnLabels={['Datum izvršnosti']} />
        <ViewTableHeaderColumn renderSort sortKey={'effectivenessDate'} columnLabels={['Datum pravomoćnosti']} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'75px'} />
      </ViewTable>
      <PreviousDocumentsDeleteModal
        isModalOpen={modalOpened}
        closeModalCallback={cancelPreviousDocumentDeletion}
        previousDocumentWebId={webIdToDelete}
      />
    </>
  );
};

export default PreviousDocumentsTable;
